<template>
  <div class="col-lg-12">
    <div class="card">
      <div class="card-body">
        <h4 class="card-title">{{ cardTitle }}</h4>

        <p class="card-title-desc">
          {{ description }}
        </p>
        <form class="needs-validation" @submit.prevent="FormSubmit()">
          <div class="row">
            <div class="col-md-6">
              <div class="mb-3">
                <label for="validationCustom01">Τίτλος Σχεσης Εργασίας</label>
                <input
                  id="validationCustom01"
                  type="text"
                  class="form-control"
                  placeholder="Τίτλος Σχεσης Εργασίας"
                  required
                  :value="value"
                  ref="relationshipTitle"
                />
              </div>
            </div>
          </div>

          <button class="btn btn-primary" type="submit">
            Ολοκλήρωση
          </button>
        </form>
      </div>
    </div>
    <!-- end card -->
  </div>
</template>

<script>
export default {
  props: {
    cardTitle: String,
    description: String,
    value: {
      required: false,
      type: String,
    },
    action: {
      required: true,
      type: String,
    },
    relationID: {
      required: false,
      type: Number,
    },
  },
  methods: {
    FormSubmit() {
      this.$emit(
        "formData",
        this.$refs.relationshipTitle.value,
        this.action,
        this.relationID
      );
      //   console.log(this.$refs.relationshipTitle.value, this.action);
    },
  },
};
</script>
